<div class="aca-sidenav">
  <app-sidenav-header (toggleNavBar)="toggleClick()" />

  <div class="aca-sidenav__section">
    <ng-container *ngFor="let group of scrollableGroups; trackBy: trackByGroupId">
      <ng-container *ngTemplateOutlet="groupActions; context: { $implicit: group }" />
    </ng-container>
  </div>

  <div class="aca-sidenav__section aca-sidenav__bottom" *ngIf="bottomGroups.length">
    <ng-container *ngFor="let group of bottomGroups; trackBy: trackByGroupId">
      <ng-container *ngTemplateOutlet="groupActions; context: { $implicit: group }" />
    </ng-container>
  </div>

  <div class="aca-sidenav__footer" *ngIf="footerGroups.length">
    <ng-container *ngFor="let group of footerGroups; trackBy: trackByGroupId">
      <ng-container *ngTemplateOutlet="groupActions; context: { $implicit: group }" />
    </ng-container>
  </div>
</div>

<ng-template #groupActions let-group>
  <div class="aca-sidenav__section__actions">
    <nav
      [attr.aria-label]="item.title | translate"
      class="aca-sidenav__section__actions__item"
      *ngFor="let item of group.items; trackBy: trackByLinkId"
    >
      <ng-container *ngIf="!item.component">
        <app-expand-menu [item]="item" />
      </ng-container>
      <ng-container *ngIf="item.component">
        <adf-dynamic-component [data]="{ item: item, state: 'expanded' }" [id]="item.component" />
      </ng-container>
    </nav>
  </div>
</ng-template>
